// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3MlOU","loadingShrink":"PageLoading_loadingShrink__1qfhA"};